import { createFileRoute, Link } from "@tanstack/react-router";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ArrowLeft, Activity } from "lucide-react";

export const Route = createFileRoute("/admin/administrateur/integration/ihe-gw/")({
  component: Page,
});

function Page() {
  return (
    <div className="space-y-4 p-6">
      <Link to="/admin/administrateur" className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground">
        <ArrowLeft className="h-3 w-3" /> Dashboard Administrateur
      </Link>
      <div>
        <div className="flex items-center gap-2 mb-1">
          
        </div>
        <h1 className="text-2xl font-bold tracking-tight">IHE Gateway</h1>
        <p className="mt-1 text-sm text-muted-foreground">XDS.b · PIX · ATNA · PDQ</p>
      </div>
      <div className="grid grid-cols-2 gap-3 md:grid-cols-4">
        <Card><CardContent className="p-4"><div className="text-xs uppercase text-muted-foreground">Transactions / jour</div><div className="mt-1 text-2xl font-bold text-emerald-400">8 421</div></CardContent></Card>
        <Card><CardContent className="p-4"><div className="text-xs uppercase text-muted-foreground">Domains</div><div className="mt-1 text-2xl font-bold text-emerald-400">12</div></CardContent></Card>
        <Card><CardContent className="p-4"><div className="text-xs uppercase text-muted-foreground">PIX matches</div><div className="mt-1 text-2xl font-bold text-emerald-400">3 142</div></CardContent></Card>
        <Card><CardContent className="p-4"><div className="text-xs uppercase text-muted-foreground">XDS.b registry</div><div className="mt-1 text-2xl font-bold text-emerald-400">OK</div></CardContent></Card>
      </div>
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Activity className="h-4 w-4" />
            Détails IHE Gateway
          </CardTitle>
          <CardDescription>Module opérationnel · branché à l'API unifiée v7.1</CardDescription>
        </CardHeader>
        <CardContent className="text-sm text-muted-foreground">
          <p>Page détaillée du module IHE Gateway. Les métriques sont collectées via OpenTelemetry et agrégées via Prometheus.</p>
        </CardContent>
      </Card>
    </div>
  );
}
